import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './badge.module.scss';

type SizeType = 'small' | 'medium' | 'large';
export type BadgeType = 'default' | 'outline' | 'new';

export type BadgeProps = {
  onClose?: () => void;
  badgeSize?: SizeType;
  type?: BadgeType;
  useFilterRedesignUi?: boolean;
  isInteractive?: boolean;
} & React.HTMLProps<HTMLDivElement>;

const Badge: React.FC<BadgeProps> = (props) => {
  const {
    children,
    className,
    onClose,
    badgeSize = 'large',
    type = 'default',
    tabIndex = 0,
    useFilterRedesignUi = false,
    isInteractive = true,
    ...rest
  } = props;

  const closable = useMemo<boolean>(() => typeof onClose === 'function', [onClose]);

  return (
    <div
      role={isInteractive ? 'button' : undefined}
      className={clsx(
        { [styles.badge]: !className },
        { [styles['badge--crossable']]: closable },
        styles[`badge_size--${badgeSize}`],
        { [styles['badge--outline']]: type === 'outline' },
        { [styles.redesignUi]: useFilterRedesignUi },
        className,
      )}
      onClick={onClose}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          onClose?.();
        }
      }}
      tabIndex={isInteractive ? tabIndex : -1}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Badge;
